import { ReactComponent as ViewProfileIconSvg } from './view-profile.svg'
export default ViewProfileIconSvg
